import React, { useContext, useRef, useState } from "react"

import useLog from "../hooks/useLog"
import RunContext from "./RunContext"
import RunCraft from "../RunCraft/Runcraft"
import { getLog, isElectron } from "../helpers/helpers"
import { retryevery_ms, trustall, tryduring_ms } from "./UserContext/UserContext"
import delay from "delay"



const RuncraftContext = React.createContext(null)

const trust_all_cache_manually = false


export const RuncraftContextProvider = (props) => {

    const function_id = "RuncraftContext(): "
    const classname = function_id
    const log = useLog(function_id)

    const runContext = useContext(RunContext)
    const run = runContext.run

    const [last_owner, set_last_owner] = useState(null)
    const [Runcraft, set_Runcraft] = useState(null)

    const state = {
        Runcraft: Runcraft,
        last_owner: last_owner,
    }

    const [isLoading, set_isLoading] = useState(false)  // ensure no concurrency, only 1 at a time


    const ready_to_set_runcraft = async () => {
        const function_id = classname + "ready_to_set_runcraft(): "
        const log = getLog(function_id)

        if (Runcraft) {
            log("Runcraft already set, aborting")
            return
        }

        log("run_owner:", run.owner.address)

        /*
        // beware RunCraft.TokenSellRequest_Admin is undefined until we call init_async()
        log("!!RunCraft=", !!RunCraft)
        log("RunCraft.TokenSellRequest_Admin=", RunCraft.TokenSellRequest_Admin)

        log("RunCraft.init_async(run)...")
        await RunCraft.init_async(run)

        log("RunCraft.TokenSellRequest_Admin=", RunCraft.TokenSellRequest_Admin)

        log("RunCraft.syncAll(run)...")
        await RunCraft.syncAll(run)
        set_Runcraft(RunCraft)

        log("\n synced RunCraft.TokenSellRequest_Admin.owner:", RunCraft.TokenSellRequest_Admin.owner,
            "\n RunCraft.TokenSellRequest_Admin.location=", RunCraft.TokenSellRequest_Admin.location
        )
        log("ready_to_set_runcraft(): !!RunCraft=", !!RunCraft)
        */

        // log("ready_to_set_runcraft() --- part 2 ---")
        const _Runcraft = await RunCraft.init_async(run)

        log("calling: await _Runcraft.syncAll(run)...")
        await _Runcraft.syncAll(run)

        // test
        log("BEFORE: \n synced TokenSellRequest_Admin.owner:", _Runcraft.TokenSellRequest_Admin.owner,
            "\n RunCraft.TokenSellRequest_Admin.location=", _Runcraft.TokenSellRequest_Admin.location)
        try {
            await _Runcraft.TokenSellRequest_Admin.sync()
        } catch (e) {
            log("ERROR at await _Runcraft.TokenSellRequest_Admin.sync():", e)
            console.error(function_id + " at await _Runcraft.TokenSellRequest_Admin.sync(): " + e)
        }
        log("AFTER: \n re-synced TokenSellRequest_Admin.owner:", _Runcraft.TokenSellRequest_Admin.owner,
            "\n RunCraft.TokenSellRequest_Admin.location=", _Runcraft.TokenSellRequest_Admin.location)

        log("step 2")
        set_Runcraft(_Runcraft)
        set_last_owner(curr_owner)  // only after set_Runcraft !
        set_isLoading(false)  // release loading lock

        // now that runcraft is loaded we can sync the inventory again
        log("calling await runContext.inventory_sync()")

        /* TODO we should add some class_origins in that call, otherwise it's too slow
            I even plan to deprecated not providing an array of class_origins for it */
        await runContext.inventory_sync()
        log("finished")
    }


    const load_Runcraft = async () => {
        const function_id = classname + "load_Runcraft(): "
        const log = getLog(function_id)

        if (run.owner.address === last_owner) return  // no new update of run
        if (isLoading || !run) return
        set_isLoading(true)  // take loading lock

        log("start, !!Runcraft=", !!Runcraft, "run.blockchain=", run.blockchain)

        if (isElectron()) {  // in prod
            ready_to_set_runcraft()
        }
        else if (!trustall && trust_all_cache_manually) {  // dev-mode = browser
            /*  // seems useless now that we deprecated all_trusted_txids
            // we retrieve the full IDB store and trust all tx://... that were previously loaded
            // this simulates trusting the entire cache (that run doesn't make work with trust:"cache" with my system)
            // we use try{}catch{} to not throw if that doesn't work, but used only for dev-mode mocking of cache
            try {
                log("devmode = browser")
                // TODO will need to check & update if names "run-browser-cache" and "run-objects" change
                var open = indexedDB.open("run-browser-cache", 1)
                open.onsuccess = () => {
                    var db = open.result
                    log("indexedDB onsuccess, db=", db)

                    var tx = db.transaction("run-objects", "readonly")
                    log("indexedDB tx=", tx)

                    var store = tx.objectStore("run-objects")
                    log("indexedDB store=", store)

                    store.getAllKeys().onsuccess = async (res) => {
                        var allkeys = res.target.result
                        for (let i_allkeys = 0; i_allkeys < allkeys.length; i_allkeys++) {
                            const key = allkeys[i_allkeys]
                            if (key.includes('tx://')) {
                                all_trusted_txids.push(key.split('tx://')[1])
                            }
                        }
                        ready_to_set_runcraft()
                    }
                }
                function get_error(eventName) {
                    ready_to_set_runcraft()
                    return () => { console.error("Error: indexedDB.open() did not succeed:", eventName, open) }
                }
                open.onabort = () => { get_error("onabort") }
                open.onclose = () => { get_error("onclose") }
                open.onerror = () => { get_error("onerror") }
                open.onversionchange = () => { get_error("onversionchange") }
            }
            catch (error) {
                console.error(function_id + error)
                ready_to_set_runcraft()
            }
            */
        }
        else {  // default
            ready_to_set_runcraft()
        }
    }

    // we use run's owner address to see it if was changed
    // in which case we need to load_Runcraft() with the new run (for the cache)
    var curr_owner = null

    if (run) {
        curr_owner = run.owner.address
        if (curr_owner !== last_owner) {
            // beware of infinite loops doing this, checks necessary in the function
            load_Runcraft()
        }
    }

    log(
        "\n !!run =", !!run,  // never log run ! contains privkeys !
        "\n !!Runcraft =", !!Runcraft,
        "\n isLoading =", isLoading,
        "\n curr_owner =", curr_owner,
        "\n last_owner =", last_owner,
    )

    return (
        <RuncraftContext.Provider value={state}>
            {props.children}
        </RuncraftContext.Provider>
    )
}

export default RuncraftContext
